/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from './util/createPromiseRequest';
import { hasAccessToken } from '../../../utils/token';
import { sortCustomers } from './util/customer';

export const fetchCustomers = async ({ format = 'OBJECT' } = {}) => {
	const url = '/customers';

	if (hasAccessToken()) {
		const fetchData = createPromiseRequest({
      url,
      method: 'POST',
      aip: 'scanline',
      data: {
        format
      }      
		});

    return fetchData().then((_customers) => { 
      const customers = _customers?.customers || _customers || [];
      const formattedUsers = [...customers];
      formattedUsers.sort(sortCustomers);
      return formattedUsers;
    });
	}
	return Promise.reject(new Error('Missing Token'));
};

